import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

/**
 * tailwind-merge has to be taught the theme's custom scales, otherwise it cannot tell
 * `text-md` (a font size) from `text-ink` (a color), or know that `rounded-input` and
 * `rounded-card` belong to the same group and must not both survive a merge.
 * Every name here comes from `theme.css`.
 */
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [{ text: ['2xs', 'xs', 'sm', 'base', 'md', 'lg', 'xl', '2xl', '3xl', '4xl'] }],
      rounded: [{ rounded: ['sm', 'input', 'button', 'card', 'md', 'lg', 'full'] }],
      shadow: [{ shadow: ['card', 'primary', 'focus', 'dropdown'] }],
      tracking: [{ tracking: ['badge'] }],
    },
  },
});

/**
 * The one class-name helper. `clsx` resolves conditionals, `twMerge` makes a later
 * class win over an earlier one in the same group, which is what lets every component
 * accept a `className` override without `!important` or ordering games.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
